export default __webpack_public_path__ + "static/media/d743b9ee7f923b19f8aba45eca699de2.svg";